import { NavItem } from '../types/appModels';

export const ADDITIONAL_NAV_ITEMS: NavItem[] = [
  {
    label: 'Document Store',
    value: '/documentstore',
    type: 'documentstore',
    path: '/documentstore',
    defaultView: false,
  },
  {
    label: 'Account',
    value: 'account',
    type: 'account',
    path: 'account',
    defaultView: false,
  },
  {
    label: 'Logout',
    value: 'logout',
    type: 'logout',
    path: '',
    defaultView: false,
  },
  {
    label: 'Support',
    value: 'support',
    type: 'support',
    path: '',
    defaultView: false,
  }
];

export const ADMIN_NAV_ITEM: NavItem = {
  label: 'Admin',
  value: '/admin',
  type: 'admin',
  path: '/admin',
  defaultView: false,
};
